export default "__VITE_ASSET__CulkbGVR__"